var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _circle, _circle2, _rect2, _path10, _rect3, _path11, _rect4, _path12, _path13, _rect5, _path14, _path15, _path16, _path17, _path18;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBox(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 96.8962C51 95.1509 52.0737 93.5856 53.7019 92.9572L77.9195 83.61C78.9339 83.2185 80.0601 83.2334 81.0638 83.6516L106.902 94.4174C108.475 95.073 109.5 96.6103 109.5 98.3148V133.457C109.5 135.274 108.337 136.888 106.613 137.462L80.8702 146.043C79.982 146.339 79.0206 146.332 78.1371 146.022L53.8243 137.491C52.1324 136.897 51 135.3 51 133.507V96.8962Z",
    fill: "#FFC100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.507 113.873L109.565 102L80 112.4L88.9347 125.757C89.8175 127.077 91.4821 127.632 92.98 127.105L115.77 119.088C117.913 118.334 118.77 115.761 117.507 113.873Z",
    stroke: "#131416",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.507 90.1271L109.565 102L80 91.6L88.9347 78.2426C89.8175 76.9228 91.4821 76.3684 92.98 76.8953L115.77 84.9121C117.913 85.666 118.77 88.2387 117.507 90.1271Z",
    stroke: "#131416",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.493 113.873L50.4348 102L80 112.4L71.0653 125.757C70.1825 127.077 68.5179 127.632 67.02 127.105L44.2299 119.088C42.0867 118.334 41.2299 115.761 42.493 113.873Z",
    stroke: "#131416",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.493 90.1271L50.4348 102L80 91.6L71.0653 78.2426C70.1825 76.9228 68.5179 76.3684 67.02 76.8953L44.2299 84.9121C42.0867 85.666 41.2299 88.2387 42.493 90.1271Z",
    stroke: "#131416",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4346 102.087L79.9998 91.6521L109.565 102.087",
    stroke: "#131416",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 122V139.117C50 140.839 51.1017 142.367 52.7351 142.912L75.5728 150.524C78.4466 151.482 81.5535 151.482 84.4272 150.524L107.265 142.912C108.898 142.367 110 140.839 110 139.117V122",
    stroke: "#131416",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113V151",
    stroke: "#131416",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.9417,
    y: 7.34021,
    width: 24,
    height: 24,
    rx: 4,
    transform: "rotate(-8 67.9417 7.34021)",
    fill: "#00C1F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.812 20.0906C78.9058 19.9369 79.9656 20.7463 79.5752 21.7796C79.0753 23.1028 77.8876 24.1193 76.3881 24.33C74.8887 24.5408 73.4667 23.891 72.6215 22.7569C71.9614 21.8712 72.7571 20.801 73.8509 20.6473L77.812 20.0906Z",
    fill: "#131416"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.0365,
    cy: 14.9839,
    r: 2,
    transform: "rotate(-8 71.0365 14.9839)",
    fill: "#131416"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.9583,
    cy: 13.8706,
    r: 2,
    transform: "rotate(-8 78.9583 13.8706)",
    fill: "#131416"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 8.17529,
    width: 24,
    height: 24,
    rx: 4,
    transform: "rotate(-8 62 8.17529)",
    stroke: "#131416",
    strokeWidth: 2.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.719 37.6767L121.994 39.0111C121.065 39.466 120.348 40.2633 119.994 41.2355L118.762 44.6209C118.007 46.6968 119.077 48.9922 121.153 49.7478L136.309 55.264C138.099 55.9157 140.079 54.9925 140.731 53.2018C141.05 52.324 141 51.3542 140.592 50.5139L138.42 46.0439C137.812 44.793 136.36 44.2011 135.051 44.6709C133.69 45.1593 132.185 44.4992 131.623 43.1675L130.163 39.7127C129.269 37.5972 126.782 36.6669 124.719 37.6767Z",
    fill: "#2C9358"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 126.559,
    y: 23.0779,
    width: 23.9328,
    height: 24,
    rx: 4,
    transform: "rotate(20 126.559 23.0779)",
    stroke: "#131416",
    strokeWidth: 2.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.712 36.5157L129.684 32.6127L133.792 42.337L138.518 40.6405L142.397 48.624",
    stroke: "#131416",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.733447,
    y: 1.5059,
    width: 2.36895,
    height: 2.38224,
    rx: 1.18447,
    transform: "matrix(0.945354 0.326046 -0.326136 0.945323 138.719 32.1701)",
    fill: "#131416",
    stroke: "#131416",
    strokeWidth: 2.36895
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6579 52.4829C16.2655 56.7402 22.0469 58.6586 24.9867 59.0856C25.8558 58.3351 30.6096 51.3885 27.1858 48.6511C24.346 46.4978 22.3452 48.7056 21.6944 50.0402C20.2224 49.1997 16.9202 49.6344 16.6579 52.4829Z",
    fill: "#FA4364"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8651 50.6577C14.4728 54.915 20.2542 56.8334 23.1939 57.2604C24.0631 56.5099 28.8168 49.5633 25.3931 46.8259C22.5533 44.6727 20.5525 46.8804 19.9017 48.215C18.4297 47.3745 15.1275 47.8092 14.8651 50.6577Z",
    stroke: "#131416",
    strokeWidth: 2.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.61914,
    y: 44.4321,
    width: 24,
    height: 24,
    rx: 4,
    transform: "rotate(-20 5.61914 44.4321)",
    stroke: "#131416",
    strokeWidth: 2.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39V54",
    stroke: "#FC8C41",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78 43V58",
    stroke: "#FC8C41",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39V54",
    stroke: "#FC8C41",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.667 73.6482C113.135 69.6054 114.826 67.0119 118.74 65.8676C122.654 64.7234 124.344 62.1299 123.812 58.087",
    stroke: "#FC8C41",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4332 62.4757C38.4332 62.4757 41.9225 61.6308 46.6315 66.3498C52.2353 71.8711 46.0966 81.764 42.0925 79.1671C39.803 77.7599 40.9752 74.763 42.4574 72.8884C43.9396 71.0138 47.7413 68.9343 52.0653 72.1161C56.6344 75.4678 58.501 80.4999 60.001 85.4999",
    stroke: "#FC8C41",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.1f0a4bf6.svg";
export { ForwardRef as ReactComponent };